module.exports = __webpack_public_path__ + "media/images/captive_portal/Guest-wifi-67b53c6b05d36f3eb6cdf7425284d281.svg";